export default "__VITE_PUBLIC_ASSET__444d362c__"